import { apiConfig } from "./restConfig";

const baseApi1 = apiConfig().apiRoot;

const httpService = ({
  url,
  body,
  hasFile = false,
  method = "GET",
  params = {},
  headers = {},
}) => {
  const rootRequest = baseApi1 + url;

  let formData, defaultHeaders;
  if (!hasFile) {
    formData = JSON.stringify(body);
    defaultHeaders = {
      "Content-Type": "application/json; charset=utf-8",
      Accept: "application/json",
      ...headers,
    };
  } else {
    formData = new FormData();
    Object.keys(body).forEach((key) => formData.append(key, body[key]));

    defaultHeaders = new Headers();
    defaultHeaders.delete("Content-Type");
  }

  let myHeaders = new Headers();
  myHeaders.delete("Content-Type");
  return new Promise((resolve, reject) => {
    fetch(rootRequest, {
      method: method,
      headers: defaultHeaders,
      body: formData,
      ...params,
    })
      .then((rawResponse) => {
        if (rawResponse.ok) {
          rawResponse
            .json()
            .then((response) => {
              resolve(response);
            })
            .catch(() => {
              resolve(rawResponse);
            });
        } else {
          rawResponse
            .json()
            .then((response) => {
              rawResponse.response = response;
              reject(rawResponse);
            })
            .catch(() => {
              reject(rawResponse);
            });
        }
      })
      .catch((error) => {
        if (!error.status) {
        } else {
          reject(error);
        }
      });
  });
};

export default httpService;
